export type JourneyChannel = 'search' | 'social' | 'tv' | 'email' | 'direct'

export interface Touchpoint {
  channel: JourneyChannel
  /** Specific source, e.g. "Meta Ad", "Google Search", "Roku Ad". */
  label: string
  /** Days before purchase this touch happened. */
  day: number
}

export interface PurchasedProduct {
  name: string
  url: string | null
  priceCents: number
}

export type CustomerStatus = 'Repeat customer' | 'Customer' | 'High value'

export interface Customer {
  id: string
  /** Anonymized display id. */
  anonId: string
  displayName?: string | null
  email: string | null
  phone: string | null
  status: CustomerStatus
  /** Distinct channels touched, in first-seen order (for chips). */
  channels: JourneyChannel[]
  products: PurchasedProduct[]
  /** Ordered path to purchase. */
  journey: Touchpoint[]
  totalSpentCents: number
  ordersCount: number
  firstSeenDaysAgo: number
  firstSeenAt?: string
  lastSeenAt?: string
}

export type ExampleCustomer = Customer

export const JOURNEY_CHANNEL_COLOR: Record<JourneyChannel, string> = {
  search: '#A8780C',
  social: '#2D6CDF',
  tv: '#7A5BD6',
  email: '#0A8A6E',
  direct: '#64748B',
}

export const JOURNEY_CHANNEL_LABEL: Record<JourneyChannel, string> = {
  search: 'Search',
  social: 'Social',
  tv: 'TV / CTV',
  email: 'Email',
  direct: 'Direct',
}

export function fmtUsd(cents: number): string {
  return `$${(cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
}

export function customerStatus(totalSpentCents: number, ordersCount: number): CustomerStatus {
  if (totalSpentCents >= 50000) return 'High value'
  if (ordersCount > 1) return 'Repeat customer'
  return 'Customer'
}

export function daysAgo(iso: string | null | undefined): number {
  if (!iso) return 0
  return Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 86_400_000))
}
